import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { requestLocalPasswordAction } from '@root/features/secure-storage/atoms'
import { WrongPasswordError } from '@root/features/secure-storage/secure-storage-error'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { Redacted } from '@blade/std-lib'
import type { WalletId } from '@root/entities/wallet'

export const exportWalletFromStorageAction = action(
  async (
    ctx,
    { walletId, password }: { walletId: WalletId; password: Redacted.Redacted },
  ) => {
    const { secureStorageService } = ctx.get(dependenciesAtom)

    return await ctx.schedule(() =>
      secureStorageService.exportWallet(walletId, password),
    )
  },
  'exportWalletFromStorageAction',
)

export const reatomExportWallet = ({ walletId }: { walletId: WalletId }) => {
  const { executeAction, requestStateAtom: exportWalletStateAtom } =
    reatomRequest({
      execAction: exportWalletFromStorageAction,
      name: `exportWallet_${walletId}`,
    })

  const exportWalletAction = action((ctx) => {
    return requestLocalPasswordAction(ctx, async (ctx, { password }) => {
      const result = await ctx.schedule(() =>
        executeAction(ctx, { password, walletId }),
      )

      if (Result.isFailure(result)) {
        if (result.failure instanceof WrongPasswordError) {
          return result
        }
        showSnackbarAction(ctx, {
          text: i18next.t('common.something-went-wrong'),
          intent: 'error',
        })
      }

      return result
    })
  }, 'exportWalletAction')

  return {
    exportWalletStateAtom,
    exportWalletAction,
  }
}
